import type { ReactElement } from "react";
import { UiIcon } from "./UiIcons";

export interface PreparationPlannerStage {
  items: string[];
  label: string;
  title: string;
}

interface PreparationPlannerProps {
  stages: PreparationPlannerStage[];
}

export const PreparationPlanner = ({ stages }: PreparationPlannerProps): ReactElement => (
  <div className="newborn-preparation-planner">
    {stages.map((stage, index) => (
      <article key={stage.title}>
        <header>
          <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
          <div>
            <p>{stage.label}</p>
            <h3>{stage.title}</h3>
          </div>
        </header>
        <ul>
          {stage.items.map((item) => (
            <li key={item}>
              <UiIcon name="check" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </article>
    ))}
  </div>
);
